export const getAdjustCustomerChargeColumns = () => {
    return {
        columns: [
            {
                field: "Name",
                title: "Name",
                wmsid: 1,
                locked: false,
                lockable: false,
            },
            {
                field: "Description",
                title: "Description",
                wmsid: 2,
                locked: false,
                lockable: false,
                headerAttributes: {
                    "data-wms-selector": "AdjustCustomerChargeDescription",
                },
            },
            {
                field: "Category",
                title: "Category",
                wmsid: 3,
                locked: false,
                lockable: false,
                headerAttributes: {
                    "data-wms-selector": "AdjustCustomerChargeCategory",
                },
            },
            {
                field: "ChargePerUnit",
                title: "Charge Amount",
                wmsid: 8,
                locked: false,
                lockable: false,
                headerAttributes: {
                    "data-wms-selector": "AdjustCustomerChargeChargeAmount",
                },
                template: function (dataItem) {
                    return dataItem.Detail && dataItem.Detail.ChargePerUnit
                        ? `$${Number(dataItem.Detail.ChargePerUnit)?.toFixed(2)}`
                        : "$0.00";
                },
            },
        ],
    };
};

export const getAdjustCustomerChargeAllColumnList = () => {
    return [
        {
            field: "Name",
            title: "Name",
            width: 500,
            wmsid: 1,
            locked: false,
            lockable: false,
            resizable: false,
            sortable: false,
            reorderable: false,
            filterable: false,
        },
        {
            field: "Description",
            title: "Description",
            wmsid: 2,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "AdjustCustomerChargeDescription",
            },
        },
        {
            field: "Category",
            title: "Category",
            wmsid: 3,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "AdjustCustomerChargeReference",
            },
        },
        {
            field: "ChargePerUnit",
            title: "Charge Amount",
            wmsid: 5,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "AdjustCustomerChargeChargeDate",
            },
        },
    ];
};

export const getAdjustCustomerChargeSchema = () => {
    return {
        model: {
            id: "RowNumber",
            fields: {
                Name: { type: "string" },
                Description: { type: "string" },
                Category: { type: "string" },
                ChargePerUnit: { type: "number" },
            },
        },
    };
};
